module.exports = "<div class=\"chips flexVerticalAlignParent flex-wrap mb8\">\n    <div class=\"chips__item\" ng-repeat=\"item in ctrl.items\">\n        <span>{{::item[ctrl.displayField]}}</span>\n        <span class=\"close-icon--tiny icon18\" ng-click=\"!ctrl.isDisabled && ctrl.onClick({item: item })\"></span>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer/modules/nfc-stickers/shared/chips/chips.component.html
// module id = 793
// module chunks = 0